<h4> LEITURA OBRIGATÓRIA: COMUNICADO AOS FORNECEDORES </h4>

<div class="form-input">
    <textarea type="text" disabled="true" class="form-input">
Prezado Fornecedor,

Em conformidade com as diretrizes internas da Masterboi e as disposições contratuais aplicáveis, comunicamos que não autorizamos, em nenhuma hipótese, a negociação, cessão, endosso ou desconto de títulos de crédito e notas fiscais emitidas em nosso nome, inclusive perante instituições financeiras, factorings ou quaisquer terceiros.

Tal prática configura descumprimento contratual e poderá ensejar a aplicação das penalidades previstas no instrumento firmado, além de outras medidas cabíveis.

Contamos com sua atenção e colaboração para o fiel cumprimento das condições pactuadas.

Atenciosamente,
Masterboi
    </textarea>
</div>

<form [formGroup]="form">
    <div class="check-container">
        <mat-checkbox color="primary" formControlName="check"
            style="font-size: 14px; font-weight: 400; color: #53565A;">
            Declaro que li e estou ciente das condições acima.
        </mat-checkbox>
    </div>
    <div class="alert-container">
        <span class="alert" [ngStyle]="{opacity: this.form.get('check')?.touched && this.form.get('check')?.value !== true  ? '1' : '0'}"> É necessário assinalar o campo para continuar. </span>
    </div>
</form>

<div class="buttons-area">
    <button type="button" class="button red" (click)=" closeModal(false)">
        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.55128 2.37356C8.89326 2.03158 8.89326 1.47711 8.55128 1.13513L8.3649 0.948748C8.02292 0.606765 7.46845 0.606765 7.12647 0.948749L4.50008 3.57514L1.87368 0.94875C1.5317 0.606766 0.977235 0.606765 0.635251 0.948749L0.44887 1.13513C0.106887 1.47711 0.106887 2.03158 0.448871 2.37356L3.07526 4.99995L0.448871 7.62634C0.106888 7.96833 0.106887 8.52279 0.448871 8.86478L0.635251 9.05116C0.977235 9.39314 1.5317 9.39314 1.87368 9.05116L4.50008 6.42477L7.12647 9.05116C7.46845 9.39314 8.02292 9.39314 8.3649 9.05116L8.55128 8.86478C8.89326 8.52279 8.89326 7.96833 8.55128 7.62635L5.92489 4.99995L8.55128 2.37356Z"
                fill="white" />
        </svg>
        <span>
            Cancelar
        </span>
    </button>

    <button type="button" [ngClass]="this.form.get('check')!.value === true ? 'button green' : 'button'"
        (click)="submitForm()">
        <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.65381 3.19235L5.42304 6.96159L11.3461 1.30774" stroke="white" stroke-width="1.61538"
                stroke-linecap="round" />
        </svg>
        <span>
            Confirmar
        </span>
    </button>
</div>
